import { List } from "immutable";
import { v4 as uuid } from "uuid";
import { withId, withoutId } from "@utils/domain";
import { contentStateFromString, contentStateToString } from "@utils/richText/converters";
import { Exercise, ExerciseChoice, ExerciseType } from "./exercise";

export interface ExerciseDto extends Omit<Exercise, "choices" | "id" | "comment" | "type"> {
	id?: string;
	choices: ExerciceChoiceDto[];
	comment: string;
	type?: ExerciseType;
}

export type ExerciceChoiceDto = Omit<ExerciseChoice, "id">;

export function exerciseToDto(exercise: Omit<Exercise, "type">): ExerciseDto {
	return withoutId({
		...exercise,
		comment: contentStateToString(exercise.comment),
		choices: exercise.choices.toArray().map(withoutId),
	});
}

export function exerciseFromDto(dto: ExerciseDto): Exercise {
	return {
		...dto,
		type: dto.type ?? "UNIQUE",
		choices: List(dto.choices).map(withId),
		comment: contentStateFromString(dto.comment),
		id: dto.id ?? uuid(),
	};
}
